var $0e92b1ed4012aa59$exports = {};
$0e92b1ed4012aa59$exports = {
    "invalidSelection": (args, formatter)=>`A(s) ${formatter.plural(args.selectedCount, {
            one: `data`,
            other: `datas`
        })} selecionada(s) n\xe3o est\xe1(\xe3o) dispon\xedvel/dispon\xedvel(eis).`
};


export {$0e92b1ed4012aa59$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
